import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';
import { persist, PersistStorage } from 'zustand/middleware';

import { timedLocalStorage } from './storage/timed-local-storage';

type ScheduleQuestionsState = {
	questionData: any[] | null;
	questionsAnswers: Record<string, string[]>;
};

type ScheduleQuestionsAnswers = {
	setQuestionData: (questionData: any[]) => void;
	setQuestionAnswer: (question: string, answer: any) => void;
};

const SCHEDULE_QUESTIONS_INITIAL_STATE: ScheduleQuestionsState = {
	questionData: null,
	questionsAnswers: {},
};

const useScheduleQuestionsStore = create<ScheduleQuestionsState & ScheduleQuestionsAnswers>()(
	persist(
		(set, get) => ({
			...SCHEDULE_QUESTIONS_INITIAL_STATE,
			setQuestionAnswer: (question, answer) =>
				set({
					questionsAnswers: {
						...get().questionsAnswers,
						[question]: answer,
					},
				}),
			setQuestionData: (questionData) => set({ questionData }),
		}),
		{
			name: 'schedule-questions-store',
			storage: timedLocalStorage(24 * 60 * 60 * 1000) as PersistStorage<any>, // 24 hours
			partialize: (s) => ({
				questionsAnswers: s.questionsAnswers,
			}),
		}
	)
);

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('useScheduleQuestionsStore', useScheduleQuestionsStore);
}

export default useScheduleQuestionsStore;
